import React, {memo} from 'react';
import {useSelector} from "react-redux";
import {ProgressBar, ProgressContainer, Strype} from "./ProgressBar";
import ReactDOM from "react-dom";

const ApiProgress = memo(()=> {
    const message = useSelector(state => state.api.apiMessage)

    // const message={
    //     done:"10",
    //     total:"50",
    //     title:"클래스 초기화 진행중"
    // }
    // console.log(message)

    if(message) {
        return (
            <>
                {/*{ReactDOM.createPortal(*/}
            <div className={`loading-message`}>
                <ProgressContainer className={'print-only-hidden'}>
                    <ProgressBar $done={parseInt(message.done)}  $total={parseInt(message.total)}  >
                        <Strype></Strype>
                    </ProgressBar>
                </ProgressContainer>

                <p className={'h-[50px] text-[22px] mt-3'}>{message.title}</p>
                <p className={'h-[50px] text-[16px] '}>진행률 {Math.floor(message.done/message.total* 100)}%  [ {message.done}/{message.total} ] </p>
            </div>
                    {/*document.body*/}
                    {/*)}*/}
            </>
        );
    }
})

export default ApiProgress;